import React from "react";
import { connect } from "react-redux";

import authAction from "../../redux/auth/action";
import { capatalize } from "../../config/helpers";
import CustomButton from "../CustomButton/CustomButton";
import "./style.css";

function CustomModel({
  type = "Error",
  alertMessage = "Something went wrong",
  secondMessage = "",
  removeAlertMessage,
  onClickSuccess = this.props.onClickSuccess,
  onClickReject = this.props.onClickReject,
  hidden = false
}) {

  return (
    <div hidden={hidden} className="alert-box-container">
      <div className="alert-box px-3 pb-4 bounce-in">
        <div className="alert-box-body">
          <img
            src={require("../../assets/icons/error.png")}
            alt="alert box icon"
            className="alert-box-icon appear-in"
          />
          <p className="alert-box-type-title my-3">{capatalize(type)}</p>
          <div className="mb-5 my-1">
            <p className="alert-box-message">{alertMessage}</p>
            {!!secondMessage && <p className="alert-box-message">{secondMessage}</p>}
          </div>
          <div className="btnContainer">
            <div className="button">
              <CustomButton
                buttonClasses={`btn-block button-width button-error`}
                buttonContainerClasses="flex1"
                buttonText="Yes"
                onClick={() => onClickSuccess()}
              />
            </div>
            <div className="button">
              <CustomButton
                buttonClasses={`btn-block button-width button-error`}
                buttonContainerClasses="flex1"
                buttonText="No"
                onClick={() => onClickReject()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  removeAlertMessage: authAction.removeAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomModel);
